import {Component, OnDestroy, OnInit} from '@angular/core';
import {HttpBackend, HttpClient} from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";
import {environment} from "../../environments/environment";
import {ParamsBuildHelper} from "../helper/params-build-helper";
import {of, switchMap, tap} from "rxjs";
import {ArticleNews} from "../model/ArticleNews";
import {catchError, map} from "rxjs/operators";

@Component({
  selector: 'app-direct-mgn-doc',
  template: `
    <app-news *ngIf="news" [articleNews]="news"></app-news>`,
  styles: []
})
export class DirectDocMGNComponent implements OnInit, OnDestroy {

  private storyId: number;
  private doc_key: string
  private sub: any;

  private httpClient: HttpClient;

  news: ArticleNews;

  constructor(httpBackend: HttpBackend,
              private activatedRoute: ActivatedRoute) {
    this.httpClient = new HttpClient(httpBackend);
  }

  ngOnInit() {
    this.sub = this.activatedRoute.queryParams.pipe(
      tap(params => {
        this.storyId = +params['story-id'];
        this.doc_key = params['doc-key'];
        if (!this.storyId) {
          throw new Error('Provide storyId');
        }
      }),
      switchMap(r => {
        const url = environment.apiUrl + '/direct-doc-mgn' + ParamsBuildHelper.buildGetParams({
          'story-id': this.storyId.toString(),
          'doc-key': this.doc_key
        });
        return this.httpClient.get<ArticleNews>(url);
      }),
      map(news => {
        this.news = news;
        return news;
      })
      , catchError(err => {
        return of('Error');
      })
    ).subscribe();
  }


  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
